const state = {
  admin: {
    token: ''
  },
  partner: {
    token: '',
    id: '',
    user_id: '',
  },
  superpartner: {
    token: '',
    id: '',
    user_id: '',
  },
  supervisor: {
    token: ''
  },
  mode:''
}

const mutations = {
  setPartner (state, value) {
    state.partner = value;
  },
  setSuperPartner (state, value) {
    state.superpartner = value;
  },
  setAdmin (state, value) {
    state.admin = value;
  },
  setSuperVisor (state, value) {
    state.supervisor = value;
  },
  logOut (state, value) {
    console.log('logout')
    if(state.mode === 'admin'){
      state.admin = {
        token: ''
      };
    }
    else if(state.mode === 'superpartner'){
      state.superpartner = {
        token:'',
        id:'',
        user_id:''
      }
    }
    else if(state.mode === 'supervisor') {
      state.supervisor = {
        token:''
      }
    }
    else{
      state.partner={
        token:'',
        id:'',
        user_id:''
      }
    }
  },
  setMode (state, value) {
    state.mode = value;
  }
}

const getters = {
  admin: state => {
    return state.admin;
  },
  partner: state => {
    return state.partner
  },
  superpartner: state => {
    return state.superpartner
  },
  supervisor: state => {
    return state.supervisor
  },
  mode: state => {
    return state.mode;
  }
}

export default {
  namespaced: false,
  state,
  mutations,
  getters
}
